import Rest from "../services/api_config/RestApi";

export default {
  getSettlementTrans(params) {
    var data = ``;
    if (params.id !== null && params.id !== undefined && params.id !== "") {
      data += `&id=${params.id}`;
    }
    if (params.mdr !== null && params.mdr !== undefined && params.mdr !== "") {
      data += `&mdr=${params.mdr}`;
    }
    return Rest().get("ticketko/common/settlement-trans?" + data.substring(1));
  },
};
